export enum enumUserBetaFlag {
  assignedCbpRequest = 'assigned_cbp_request',
  bankTransfer = 'bank_transfer',
  isfDesktop = 'front_end_isf_desktop',
  lcl = 'front_end_lcl',
  isfOcr = 'isf_ocr',
  esBrokerDesktop = 'front_end_broker_entry_desktop',
  esSelfDesktop = 'front_end_self_entry_desktop',
  esOcrRedesign = 'es_ocr_redesign',
  esOcrProcessing = 'es_ocr_processing',
  onboardingRedesign = 'onboarding_redesign',
  importCustomsFromExcelFeature = 'import_customs_from_excel_feature',
  esTruckerIntegration = 'es_trucker_integration',
  paypalFastCheckout = 'paypal_fast_checkout',
  fcl = 'fcl',
  poaDocusign = 'poa_docusign',
  htsClassificationAssistant = 'hts_classification_assistant',
}
